import { useRef } from 'react';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import type { RoutableCIDRFormData } from '#screens/routes/form/routable-cidr/routable-cidr-schema.ts';
import { RoutableCIDRForm } from '#screens/routes/form/routable-cidr/RoutableCIDRForm.tsx';
import { page, Titled } from '#util/title.ts';

type Props = {
  cidr: RoutableCIDRFormData;
  onSave: (cidrConfig: RoutableCIDRFormData) => void;
  onCancel: () => void;
};

/**
 * {@link EditCIDRModal} shows a form for editing a routable CIDR.
 */
export function EditCIDRModal({ cidr, onSave, onCancel }: Props) {
  const modalRef = useRef(null);

  return (
    <Modal isOpen={true} onClose={onCancel} ref={modalRef}>
      <Titled title={() => page('Add CIDR')}>
        <ModalHeader>Edit CIDR</ModalHeader>
        <ModalBody>
          <RoutableCIDRForm onSave={onSave} defaultValues={cidr} />
        </ModalBody>
        <ModalFooter>
          <ConfirmButtonGroup
            variant="right"
            primaryButton={
              <Button type="submit" form="add-routable-cidr">
                Save
              </Button>
            }
            secondaryButton={
              <Button variant="link" onClick={onCancel}>
                Cancel
              </Button>
            }
          />
        </ModalFooter>
      </Titled>
    </Modal>
  );
}
